import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYcombinatorComponent } from './simple-icons-ycombinator.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYcombinatorComponent ],
    exports:      [ SimpleIconsYcombinatorComponent ],
    bootstrap:    []
})
export class SimpleIconsYcombinatorModule {}
